import React from "react";

import styled from "styled-components/macro";

import { useHasDescriptionOrMedia, useMediaSettings } from "Signups/stateHooks";
import { AnimatePresence, motion } from "framer-motion";

import { animate, initial } from "../animation";

export function SignupImage() {
  const { mediaSettings } = useMediaSettings();
  const { imageUrl } = mediaSettings;

  const { hasTwoColumns } = useHasDescriptionOrMedia();

  return (
    <AnimatePresence>
      <ImageWrapper
        initial={initial}
        animate={animate}
        data-cy="public-signup-image"
        $center={!hasTwoColumns}
      >
        <Img src={imageUrl} alt="making the signup page look a little nicer" />
      </ImageWrapper>
    </AnimatePresence>
  );
}

SignupImage.propTypes = {};

const ImageWrapper = styled(motion.div)`
  display: flex;
  justify-content: ${({ $center }) => ($center ? "center" : "flex-start")};
  width: 100%;
  margin-block-end: 1.5rem;
`;

const Img = styled.img`
  max-width: 100%;
  max-height: 400px;
  border-radius: 0.625rem;
`;